import React from "react";
import Meal from "../Meal/Meal";
import { useMeals } from "../Meal/MealsContext";

const Category = ({ name, twocols = false }) => {
  const { meals } = useMeals();
  const isLoading = meals.length === 0;

  // Filter meals by category
  const filteredMeals = meals.filter(
    (meal) => meal.fields["Catégorie"] === name
  );
  const half_length = Math.ceil(filteredMeals.length / 2);
  const leftMeals = filteredMeals.slice(0, half_length);
  const rightMeals = filteredMeals.slice(half_length, filteredMeals.length);
  return (
    <>
      <div id={name} className="px-5">
        <h2 className="text-xl md:text-2xl mb-4 uppercase text-center  text-secondary">
          {name}
        </h2>
        {twocols ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12 m-auto max-w-[1400px]">
            <div className="w-full mx-auto  max-w-xl">
              {isLoading ? (
                <div className="w-full max-w-xl max-h-xl h-80 bg-gray-400 opacity-30 rounded"></div>
              ) : (
                leftMeals.map((meal) => <Meal key={meal.id} meal={meal} />)
              )}
            </div>
            <div className="w-full mx-auto  max-w-xl">
              {isLoading ? (
                <div className="w-full max-w-xl max-h-xl h-80 bg-gray-400 opacity-30 rounded"></div>
              ) : (
                rightMeals.map((meal) => <Meal key={meal.id} meal={meal} />)
              )}
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 max-w-xl m-auto">
            {isLoading ? (
              <div className="w-full max-w-xl max-h-xl h-80 bg-gray-400 opacity-30 rounded"></div>
            ) : (
              filteredMeals.map((meal) => <Meal key={meal.id} meal={meal} />)
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Category;
